import { REDUX_APP_BASE } from './redux';
export const TOGGLE_SIDEBAR = `${REDUX_APP_BASE}/TOGGLE_SIDEBAR`;
export const CLOSE_SIDEBAR = `${REDUX_APP_BASE}/CLOSE_SIDEBAR`;
export const SET_DISCLAIMERS = `${REDUX_APP_BASE}/SET_DISCLAIMERS`;
export const TOGGLE_NAV_BAR_STATE = `${REDUX_APP_BASE}/TOGGLE_NAV_BAR_STATE`;
